import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { LocalStorageIdentifier } from 'config/storage'

type QueryDefaults = {
  limit: number
}

type Setters = {
  setLimit: (newLimit: number) => void
}

export const useStore = create<QueryDefaults & Setters>()(
  persist(
    immer((set) => ({
      limit: 20,
      owner: 'nativewaves',
      setLimit: (newLimit) => set((state) => void (state.limit = newLimit)),
    })),
    {
      name: LocalStorageIdentifier.QUERY_PARAMETER_DEFAULTS,
    },
  ),
)

export const selectLimit = (state: QueryDefaults) => state.limit

export const selectSetters = (state: Setters) => ({
  setLimit: state.setLimit,
})
